import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["data", "basepath", "onTabClick", "defaultActiveTabId"];
import React, { useContext, useRef, useState, useEffect } from 'react';
import { AnalyticsContext, AnalyticsLocationConsumer, trackEvent } from 'latitude-analytics';
import { StyledTabNavigationContainer, StyledTabNavigationLink, StyledTabNavigationBaseline } from './TabNavigation.styled';
const TabNavigation = _ref => {
  let {
      data,
      basepath,
      onTabClick,
      defaultActiveTabId
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    0: analytics
  } = useContext(AnalyticsContext);
  const {
    0: activeLinkId,
    1: setActiveLinkId
  } = useState(null);
  const handleOnClick = (event, linkId, location) => {
    trackEvent(analytics, {
      category: 'tab',
      action: 'in-page-navigation',
      label: event.target.innerText,
      location
    });
    if (onTabClick) {
      onTabClick(linkId);
    }
    setActiveLinkId(linkId);
  };
  const setActiveLinkRef = linkRef => {
    const rect = linkRef.current.getBoundingClientRect();
    // Sets current active item to be within window
    if (Math.round(rect.right) > window.innerWidth) {
      linkRef.current.parentNode.scrollLeft = rect.right - window.innerWidth + 24;
    }
    const links = _toConsumableArray(linkRef.current.parentNode.children);
    links.map(link => {
      link.classList.remove('isActive');
    });
    linkRef.current.classList.add('isActive');
  };
  const checkForActiveLink = (linkId, linkRef) => {
    const linkPath = `${basepath}${linkId}`;
    if (window.location.pathname === linkPath || window.location.href.indexOf(linkPath) >= 0) {
      setActiveLinkRef(linkRef);
      setActiveLinkId(linkId);
      return true;
    } else if (defaultActiveTabId === linkId) {
      setActiveLinkRef(linkRef);
      setActiveLinkId(defaultActiveTabId);
      return true;
    }
    return false;
  };
  return /*#__PURE__*/React.createElement(StyledTabNavigationContainer, rest, data.map((link, id) => {
    const linkRef = useRef(null);
    const linkId = link.id;
    useEffect(() => {
      checkForActiveLink(linkId, linkRef);
    }, [activeLinkId]);
    return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, {
      key: id
    }, location => /*#__PURE__*/React.createElement(StyledTabNavigationLink, {
      ref: linkRef,
      key: linkId,
      img: link.img,
      href: `${basepath}${linkId}`,
      onClick: event => {
        handleOnClick(event, linkId, location);
      }
    }, link.label));
  }), /*#__PURE__*/React.createElement(StyledTabNavigationBaseline, null));
};
export default TabNavigation;